import { defineComponent as m, ref as i, computed as c, openBlock as s, createElementBlock as r, normalizeClass as f, normalizeStyle as v, renderSlot as o, createCommentVNode as p } from "vue";
import { useElementBounding as u } from "@vueuse/core";
const B = /* @__PURE__ */ m({
  __name: "v-input-container",
  setup($) {
    const a = i(), d = i(), t = u(a), n = u(d), l = c(() => ({
      start: Math.ceil((t == null ? void 0 : t.width.value) ?? 0),
      end: Math.ceil((n == null ? void 0 : n.width.value) ?? 0)
    }));
    return (e, k) => (s(), r("div", {
      class: f(["v-input-container", {
        "adorn-start": e.$slots.start !== void 0,
        "adorn-end": e.$slots.end !== void 0
      }]),
      style: v({
        "--pad-start": l.value.start + "px",
        "--pad-end": l.value.end + "px"
      })
    }, [
      e.$slots.start ? (s(), r("span", {
        key: 0,
        class: "v-input-adornment prefix",
        ref_key: "adornmentStart",
        ref: a
      }, [
        o(e.$slots, "start")
      ], 512)) : p("", !0),
      o(e.$slots, "input"),
      e.$slots.end ? (s(), r("span", {
        key: 1,
        class: "v-input-adornment suffix",
        ref_key: "adornmentEnd",
        ref: d
      }, [
        o(e.$slots, "end")
      ], 512)) : p("", !0)
    ], 6));
  }
});
export {
  B as default
};
